import styled from "styled-components";

export const Wrapper = styled.div`
  @media not print {
    .sidebar-wrapper {
      background: #e6e6e6;
      border-left: 1px solid #c3c3c3;
      display: flex;
      flex-direction: column;
      height: 100%;
      position: absolute;
      left: 0;
      transition: all 0.1s;
      width: 310px;
    }
  }

  &.hide {
    .sidebar-wrapper {
      width: 0;
      border: none;
    }

    .sidebar {
      overflow: hidden;
    }
  }

  .sidebar {
    overflow-x: hidden;
    height: 100%;
    position: relative;

    .close-button {
      position: absolute;
      top: 17px;
      left: 10px;
    }

    .header {
      font-size: 20px;
      padding: 28px;
      padding-left: 60px;
      border-bottom: 1px solid #c3c3c3;
    }

    .content {
      padding: 28px;
    }

    .label {
      margin-top: 28px;
      margin-bottom: 7px;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: bold;
    }

    .sub {
      margin-top: 7px;
      margin-left: 25px;
    }

    .label,
    .ui.checkbox,
    .ui.dropdown {
      min-width: 243px;
    }
  }

  .toggle {
    color: #146e93;
    position: fixed;
    top: 90px;
    left: 90px;
    cursor: pointer;
    transition: all 0.1s ease-out;
    user-select: none;

    padding: 0.3rem 0.5rem;
    border-radius: 5px;
    background-color: #e0e0e0;    


    &:hover {
      color: #084a65;
      transition: all 0.2s ease-out;
      border-radius:1px;

      i {
        //transform: translateX(0);
        //opacity: 0.99;
        //transition: all 0.2s ease-out;
      }
    }

    i {
      //transform: translateX(10px);
      //opacity: 0;
      font-size: 19px !important;
      //transition: all 0.1s ease-out;
    }

    span {
      font-size: 14px !important;
      font-weight: bold;
      //position: absolute;
      //top: 1px;
      //left: 23px;
    }
  }

  @media print {
    display: none;
  }
`;

export const SelectDomainsInputWrapper = styled.div`
  .check-icon,
  .cross-icon {
    position: absolute;
    position: absolute;
    left: 0;
    bottom: -3px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/Sidebar/style.js